import { useCallback } from "react";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import { FundManagerDetailDrawer } from "@/components/FundManagerDetailDrawer/FundManagerDetailDrawer";
import { FundManagerList } from "@/components/FundManagerList/FundManagerList";
import type { FundManagerListItemProps } from "@/components/FundManagerListItem/FundManagerListItem";
import { useDisclosureData } from "@/services/useDisclosureData";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxManagerPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxManagerPanel: props, translations } = dashboard;

	const [isFundManagerDrawerOpen, onFundManagerDrawerOpen, onFundManagerDrawerClose, fundManagerDrawerData] =
		useDisclosureData<FundManagerListItemProps>();

	const onFundManagerClick = useCallback(
		(item: FundManagerListItemProps) => {
			return () => {
				if (item.managerURL) {
					return window.open(item.managerURL, "_blank");
				}
				return onFundManagerDrawerOpen(item);
			};
		},
		[onFundManagerDrawerOpen]
	);

	if (!props) {
		return null;
	}

	const { heading, tooltip, items, managerLabel, managerStartDateLabel, managerTermLabel } = props;

	return (
		<>
			<ContentBlock
				id="fxManagerPanel"
				data-testid="FxManagerPanel"
				heading={htmlify(heading)}
				tooltip={htmlify(tooltip)}
				flex={flex}
				tabIndex={-1}
			>
				<FundManagerList
					onItemClick={onFundManagerClick}
					items={items}
					managerStartDateLabel={managerStartDateLabel}
					managerTermLabel={managerTermLabel}
					translations={translations}
					isOpen={isFundManagerDrawerOpen}
				/>
			</ContentBlock>
			<FundManagerDetailDrawer
				heading={htmlify(managerLabel)}
				isOpen={isFundManagerDrawerOpen}
				onClose={onFundManagerDrawerClose}
				fundManager={
					fundManagerDrawerData
						? {
								...fundManagerDrawerData,
								managerStartDateLabel,
								managerTermLabel
							}
						: undefined
				}
				translations={translations}
				content={fundManagerDrawerData?.biography}
			/>
		</>
	);
};
